import { Inject } from '../Application';
import { Constants } from '../Contract';
var Modal = (function () {
    function Modal(inject) {
        if (inject === void 0) { inject = null; }
        var myInject = inject || Inject.Instance;
        this.invoker = myInject.resolve(Constants.Invoker);
        this.library = myInject.resolve(Constants.Library);
    }
    Modal.prototype.invoke = function (command) {
        this.invoker.invoke(command);
    };
    Modal.prototype.executeLoad = function () {
        if (this.onLoad) {
            this.onLoad();
        }
    };
    return Modal;
}());
export { Modal };
